/**
 * @file
 * @author qiaogang
 * @date 2019-12-12
 */
// console.log(process.env,'process.env');
// export const Config = {
//   passgoServer: process.env.VUE_APP_PASSGO_SERVER,
//  snddwechatMiniAppId: process.env.VUE_APP_WECHAT_MINI_APPID_SNDD,
//  dywechatMiniAppId: process.env.VUE_APP_WECHAT_MINI_APPID_YDY
// };
export const Config = {
  passgoServer: process.env.VUE_APP_PASSGO_SERVER,
  wechatMiniAppId: process.env.VUE_APP_WECHAT_MINI_APPID,
  ptIntroId: process.env.VUE_APP_PT_INTRO_ID,
  habitMiniAppid: 'wx229ca481a87c6bfc',   // 习惯养成小程序APPID
  habitMiniOriginId: 'gh_dea86ddf7465',   // 习惯养成小程序原始ID
  mallMiniAppid: 'wxa4a1b5ec651cc7b9',   // 少年得到知识课堂小程序APPID
  mallMiniOriginId: 'gh_a0a06cc3e970',    // 少年得到知识课堂原始ID（商城小程序）
  habitHomeRouter: '/pages/courseHome/index',
};

